module.exports = __webpack_public_path__ + "static/media/settingsParental.7efa84df.svg";